import moment from 'moment';

const calculateAge = (dob: string): number | null => {
  if (!dob) return null;

  const supportedFormats = [
    moment.ISO_8601,
    'YYYY-MM-DD',
    'MM-DD-YYYY',
    'DD-MM-YYYY',
    'YYYY/MM/DD',
    'MM/DD/YYYY',
    'DD/MM/YYYY',
    'MMM DD, YYYY',
    'MMMM DD, YYYY',
    'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ',
    'ddd, DD MMM YYYY HH:mm:ss [GMT]',
  ];

  // First try strict parsing
  let birthDate = moment(dob, supportedFormats, true);

  // If that fails, fallback to automatic (non-strict) parsing
  if (!birthDate.isValid()) {
    birthDate = moment(dob); // relaxed parse, handles "GMT+0000 (GMT)"
  }

  if (!birthDate.isValid()) return null;

  return moment().diff(birthDate, 'years');
};


export default calculateAge;